<h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>{{this.localiser.get("newEnterprise.title")}}</h1>

<div mat-dialog-content class="bodyForm">
  <div class="row rowForm">
    <div class="col">
      <h4 class="textS+">{{this.localiser.get("newEnterprise.name")}}</h4>
      <input [(ngModel)]="nombre" type="text" class="inputWidth textS" maxlength="30">
    </div>
    <div class="col">
      <h4 class="textS+">{{this.localiser.get("newEnterprise.cif")}}</h4>
      <input [(ngModel)]="CIF" type="text" class="inputWidth textS" maxlength="15">
    </div>
  </div>
  <div class="row rowForm">
    <div class="col">
      <h4 class="textS+">{{this.localiser.get("newEnterprise.address")}}</h4>
      <input [(ngModel)]="direccion" type="text" class="inputWidth textS" maxlength="30">
    </div>
    <div class="col">
      <h4 class="textS+">{{this.localiser.get("newEnterprise.phone")}}</h4>
      <input [(ngModel)]="telefono" type="text" class="inputWidth textS" maxlength="25">
    </div>
  </div>
  <div class="row rowForm">
    <div class="col">
      <h4 class="textS+">{{this.localiser.get("newEnterprise.email")}}</h4>
      <input [(ngModel)]="email" type="text" class="inputWidth textS" maxlength="50">
    </div>
    <div class="col-6">
      <!--
      <h4 class="textS+">{{this.localiser.get("newEnterprise.logo")}}</h4>
      <input [(ngModel)]="logo" type="text" class="inputWidth textS" maxlength="20">
      -->
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
  </div>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="newEmpresa()">{{this.localiser.get("button.create")}}</button>
  </div>
</div>
